import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import './student-list-section.scss';
import styled from 'styled-components';
import Triangle from '../../../../Triangle/Triangle';
import Tooltip from '../../../../common/Tooltip/Tooltip';
import AvatarRenderer from '../../../../common/AvatarRenderer/AvatarRenderer';
import AssignmentContext from '../../../../common/AssignmentContext/AssignmentContext';

const SectionHeader = ({
  toggleSection,
  isOpen,
  groupControlItems,
  name,
  count,
  labelColor,
}) => {
  const { t, i18n } = useTranslation();
  const {
    assignmentData: { assignmentType },
  } = useContext(AssignmentContext);

  return (
    <div
      className="section_header"
      data-testid="submission-section-header"
      onClick={toggleSection}
    >
      <div className="section_header__heading_container">
        <div
          className="section_header__label_color"
          style={{ backgroundColor: labelColor }}
        />
        <Triangle
          direction={isOpen ? 'down' : 'right'}
          testId="section-header-toggle-icon"
          className={`${assignmentType
            .split('_')
            .join('-')
            .toLowerCase()}-class-dashboard-${name
            .split(' ')
            .join('-')
            .toLowerCase()}-section`}
        />
        <div className="section_header__student-info" data-dd-privacy="mask">
          <span>{t(name)}</span>
          <span className="section_header__students-count">{count}</span>
        </div>
      </div>
      {/* <div className="section_header__heading_container_sticky" /> */}
      {groupControlItems && (
        <div className="section_header__group-control-items" dir={i18n.dir()}>
          {groupControlItems}
        </div>
      )}
    </div>
  );
};

SectionHeader.defaultProps = {
  groupControlItems: null,
  labelColor: 'transparent',
};

SectionHeader.propTypes = {
  toggleSection: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  groupControlItems: PropTypes.element,
  name: PropTypes.string.isRequired,
  hasItems: PropTypes.bool.isRequired,
  count: PropTypes.string.isRequired,
  labelColor: PropTypes.string.isRequired,
};

export const StudentInfo = ({ avatar, studentName, studentUsername }) => (
  <div className="student-info usprivacy" data-recording-sensitive>
    <span data-testid={`avatar-${studentUsername}`} className="student-avatar">
      <AvatarRenderer src={avatar} size={20} />
    </span>
    <span
      className="student-name usprivacy"
      data-html={true}
      data-tip={
        studentUsername
          ? `<div class="usprivacy" data-recording-sensitive>${studentName} - ${studentUsername}</div>`
          : ''
      }
      data-testid="student-name"
    >
      {studentName}
    </span>
  </div>
);

StudentInfo.defaultProps = {
  avatar: '',
};

StudentInfo.propTypes = {
  avatar: PropTypes.string,
  studentName: PropTypes.string.isRequired,
  studentUsername: PropTypes.string.isRequired,
};

export const NewStudentListSection = ({
  customCount,
  groupControlItems,
  sectionItems,
  sectionName,
  submissions,
  labelColor,
  ...rest
}) => {
  const [isOpen, setisOpen] = React.useState(true);

  useEffect(
    () => {
      ReactTooltip.rebuild();
    },
    [submissions],
  );

  const count = (submissions && submissions.length) || 0;

  // if submissions !== null then render
  return (
    submissions && (
      <StudentListSectionStyled data-testid={rest['data-testid']}>
        <SectionHeader
          hasItems={count}
          count={count}
          name={sectionName}
          isOpen={isOpen}
          toggleSection={() => setisOpen(prev => !prev)}
          groupControlItems={groupControlItems}
          labelColor={labelColor}
        />
        {isOpen && (
          <>
            <SectionItemsContainer isOpen={isOpen}>
              {sectionItems}
            </SectionItemsContainer>
          </>
        )}
        {isOpen && <Tooltip />}
      </StudentListSectionStyled>
    )
  );
  /* return <Table rows={} columns={[{key: "Students", width: '278px'}, {key: "Status", flex: 1}]} isSticky={true}
                      translationKeys={t}/> */
};

NewStudentListSection.defaultProps = {
  submissions: null,
  groupControlItems: null,
  customCount: 0,
  sectionItems: null,
  labelColor: 'transparent',
};

NewStudentListSection.propTypes = {
  groupControlItems: PropTypes.element,
  sectionName: PropTypes.string.isRequired,
  customCount: PropTypes.string,
  sectionItems: PropTypes.node,
  submissions: PropTypes.arrayOf(PropTypes.any),
  labelColor: PropTypes.string,
};

const SectionItemsContainer = styled.div``;
const StudentListSectionStyled = styled.div`
  margin-bottom: 0;
`;
